<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Pz5yQK/tc-custom/9781607057208.jpg?1703867852841" alt="This image is the cover for the book Brave New Quilts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brave New Quilts
      </h1>
      <p class="bookDescription body article font2">
        <b>The beloved quilt artist explores the use of line, color, motif, and text in this quilting guide featuring 12 projects inspired by modern art movements.</b><br/><br/>Kathreen Ricketson was one of Australia’s most popular modern quilt artists and bloggers. In <i>Brave New Quilts</i>, she combines her fine art background with her love of craft to offer a series of quilts evoking the aesthetics of Art Deco, Bauhaus, Abstract Expressionism, and even Dada. Each chapter focuses on a different design principle with 3 quilt projects presented with 2 alternate design options.<br/><br/>Kathreen shares a historical overview of each art movement, giving essential context to each project. A must-have for fans of the modern quilt movement, <i>Brave New Quilts</i> includes expert information on color, fabric selection, inspiration, and mood boards. A comprehensive appendix and in-depth information on tools and finishing techniques round out this inspiring book.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathreen Ricketson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fe95df0